module.exports = __webpack_public_path__ + "static/media/keybase.112e041e.svg";